<div class="frame-clip">
  <iframe [src]="cookieUrl" class="cookie-frame"></iframe>
</div>
